import React from "react";
import Logo from "../images/toplogo.png";
import TopImage from "../images/Hero1.jpg";
import Footer from "../Footer";
import Navbar from "../Navbar"; // Optional if you want a navbar at the top
import WhyChoose from "../WhyChoose";
import Values from "../Values";

const About = () => {
  return (
    <>
      <Navbar />

      {/* Hero Section */}
        <div className="relative pt-4">
  <img
    src={TopImage}
    alt="Topimage"
    className="w-full max-h-[500px] object-cover object-center"
  />
  <div className="absolute inset-0 flex items-center justify-center bg-black/40">
    <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white text-center">
      Who we are?
    </h2>
  </div>
</div>

      {/* About Section */}
      <section className="relative bg-gradient-to-b from-white to-gray-50 py-20 overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="md:w-2/3 text-center md:text-left">
            <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight">
              About <span className="text-orange-600">iNVORA</span>
            </h1>
            <p className="mt-4 text-lg text-gray-700 leading-relaxed max-w-xl">
              <strong>iNVORA TECHNOLOGY PRIVATE LIMITED</strong>, an integrated
              engineering company formed in 2016-2017, is a growing leader in
              Engineering Services for Automotive, Off-highway Vehicles, and
              Switchgear industries. Our deep domain expertise has made us a
              trusted partner for numerous Indian companies, delivering product
              design and development tailored to evolving global demands.
            </p>
          </div>
          <div className="relative flex justify-center md:justify-end w-full md:w-auto">
  <img
    src={Logo}
    alt="Company Logo"
    className="h-64 w-40 sm:h-32 sm:w-32 md:h-48 md:w-48 object-contain"
  />
</div>
        </div>

        {/* Decorative Background SVG */}
        <div
          className="absolute top-0 left-1/2 transform -translate-x-1/2 w-full h-full z-0 opacity-5 pointer-events-none"
          aria-hidden="true"
        >
          <svg
            className="absolute inset-0 w-full h-full"
            viewBox="0 0 1000 1000"
            fill="none"
          >
            <circle cx="500" cy="500" r="400" fill="url(#grad)" />
            <defs>
              <linearGradient id="grad" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#3b82f6" />
                <stop offset="100%" stopColor="#06b6d4" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      </section>


     <WhyChoose/>

{/* Mission, Vission, values */}
    <Values/>

      {/* Footer */}
      <Footer />
    </>
  );
};

export default About;
